// auths
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

// schedule
export const SCHEDULE_GET = 'SCHEDULE_GET';
export const SCHEDULE_PICK = 'SCHEDULE_PICK';
export const SCHEDULE_SELECT = 'SCHEDULE_SELECT';
export const SCHEDULE_BOOK = 'SCHEDULE_BOOK';

// settings
export const SETTING_GET = 'SETTING_GET';
export const SCHEDULE_SETTING_SET = 'SCHEDULE_SETTING_SET';

// appointments
export const APPOINTMENT_GET = 'APPOINTMENT_GET';
export const APPOINTMENT_HISTORY_GET = 'APPOINTMENT_HISTORY_GET';

// relation
export const RELATION_GET = 'RELATION_GET';

// redirects
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js